import { Layout } from "@/components/layout/Layout";
import {
  LoadI18nMessagesProps,
  loadIntlMessages,
} from "@/utils/loadIntlMessages";
import { getStrapiCollection, getStrapiEntity } from "@/utils/strapi";
import { routes } from "@/routes/routes";
import { querySolutionProPage } from "@/strapiQuery/solutionPro";
import { SolutionProPageContent } from "@/components/pages/solutionPro/SolutionPro";
import { AgencyB2B, queryAgenciesB2B } from "@/strapiQuery/agenciesB2B";

export const getStaticProps = async (ctx: LoadI18nMessagesProps) => {
  const layoutPromise = getStrapiEntity<Layout>("layout", "");
  const solutionProPageContentPromise = getStrapiEntity<SolutionProPageContent>(
    "solution-pro",
    querySolutionProPage
  );
  const agenciesB2BPromise = getStrapiCollection<AgencyB2B[]>(
    "agencies-b2b",
    queryAgenciesB2B
  );

  const [layout, solutionProPageContent, agenciesB2B] = await Promise.all([
    layoutPromise,
    solutionProPageContentPromise,
    agenciesB2BPromise,
  ]);

  const intlMessages = loadIntlMessages(ctx);

  return {
    props: {
      layout,
      ...solutionProPageContent,
      agenciesB2B,
      intlMessages,
      defaultCanonicalRoute: routes.solutionPro,
    },
    revalidate: 10,
  };
};

export { SolutionPro as default } from "@/components/pages/solutionPro/SolutionPro";
